import { AfterViewInit, Component, Inject, inject, Input, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { DATE_OPTIONS, DateOptions, LoggingService, LoyaltyFeed, LoyaltyFeedCardType } from '@fgb/core';
import { FeedBaseComponent } from '../../feed-base';
import { componentCardTypes, rewardCardTypes } from '../loyalty-card-registry';
import { loyatlyFeedComponentMap } from '../loyalty-feed-component-map';
import { REWARD_TYPE_CONFIG, RewardCardType, RewardTypeConfig } from '../reward-type.config';

@Component({
  selector: 'fgbcl-loyalty-feed-item',
  templateUrl: './loyalty-feed-item.component.html',
  styleUrl: './loyalty-feed-item.component.scss',
})
export class LoyaltyFeedItemComponent extends FeedBaseComponent implements AfterViewInit {
  @Input() feed!: LoyaltyFeed;
  @ViewChild('container', { read: ViewContainerRef, static: false }) private container!: ViewContainerRef;
  component: TemplateRef<any> | undefined;
  cardType = LoyaltyFeedCardType;
  rewardType: RewardTypeConfig;
  private loggingService = inject(LoggingService);

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {
    super();
  }

  /* ================================
   * Lifecyle Hooks
   * ================================ */

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    this._init();
  }

  /* ================================
   * Private Helpers
   * ================================ */

  /**
   * Initializes card behavior (reward config or dynamic component)
   * depending on the card type.
   */
  private _init(): void {
    // If card type is a reward then initialize the config for labels, buttons.etc...
    if (this.isRewardCardType) {
      this.rewardType = REWARD_TYPE_CONFIG[this.feed.CardType as RewardCardType];
      return;
    }

    // If card type is a component, create the component
    if (this.isComponentCardType) {
      this.createComponent(this.feed.CardType);
      return;
    }
  }

  /**
   * Create dynamic component
   */
  private createComponent(cardType: LoyaltyFeedCardType): any {
    let component = this.getComponent(cardType);

    if (!component) {
      this.loggingService.error(`There is no component of cardType: ${cardType}.`);
      return;
    }

    this.container.clear();
    const componentRef = this.container.createComponent(component);

    componentRef.setInput('feed', this.feed);
  }

  /**
   * Get component from component map by Loyalty Card Type
   */
  private getComponent(type: LoyaltyFeedCardType) {
    return loyatlyFeedComponentMap[type];
  }

  get isComponentCardType(): boolean {
    return componentCardTypes.has(this.feed.CardType);
  }

  get isRewardCardType(): boolean {
    return rewardCardTypes.has(this.feed.CardType);
  }

  getRewardRoute(data: any): string[] {
    const routes: Record<number, string[]> = {
      1: ['/rewards/wallet/details', `${data.LogId}_1`],
      2: ['/rewards/wallet/raffledetails', `${data.Id}_2`],
      3: ['/rewards/bids/details', `${data.Id}_3`],
    };
    return routes[data.ItemType] ?? [];
  }
}
